import React from 'react';
// @ts-ignore
import { Footer } from '@els/els-react--footer';
import './GeneralFooter.scss';
import { useSelector } from 'react-redux';
import { selectAppConfigs } from '../../features/app-config/app-config-selector';

const GeneralFooter = () => {
    const appConfigs = useSelector(selectAppConfigs);

    return (
        <Footer
            className="general-footer"
            helpLink={`${appConfigs.SUPPORT_HUB_HOME_URL}`}
            shouldShowHelpLink
            legalEntity="Elsevier Inc."
            accessibilityLink="https://service.elsevier.com/app/answers/detail/a_id/38548/c/10543/supporthub/clinical-learning-hub/"
            applicationLinks={[
                {
                    children: 'Resource center',
                    href: 'https://elsevierresources.com/clinical-learning-hub/',
                    isExternal: true,
                    noExternalIcon: false,
                },
            ]}
        />
    );
};

export default GeneralFooter;
